<template>
    <f7-page class="page-simple-account">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>TẠO TÀI KHOẢN KHÁCH</f7-nav-title>
        </f7-navbar>
        <f7-list form inset class="mb-2" autocomplete="off" >
            <f7-list-input
                type="text"
                placeholder="Tài khoản"
                :value="form_register.username"
                @input="form_register.username = $event.target.value"
            >
                <f7-icon ios="f7:person" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Mật khẩu"
                pattern="[0-9]{8}"
                inputmode="numeric"
                maxlength="8"
                info="Mật khẩu gồm 8 số"
                autocomplete="off"
                @blur="$event.target.type = 'password'"
                @focus="$event.target.type = 'text'"
                :value="form_register.password"
                @input="form_register.password = $event.target.value"
            >
                <f7-icon ios="f7:lock" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Nhập lại Mật khẩu"
                pattern="[0-9]{8}"
                inputmode="numeric"
                maxlength="8"
                autocomplete="off"
                @blur="$event.target.type = 'password'"
                @focus="$event.target.type = 'text'"
                :value="form_register.password_confirmation"
                @input="form_register.password_confirmation = $event.target.value"
            >
                <f7-icon ios="f7:lock" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Họ tên"
                :value="form_register.fullname"
                @input="form_register.fullname = $event.target.value"
            >
                <f7-icon ios="f7:doc_person" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Mã giới thiệu"
                readonly
                :value="form_register.referal"
            >
                <f7-icon ios="f7:qrcode" slot="media"></f7-icon>
            </f7-list-input>
        </f7-list>
        <f7-block inset class="mt-1">
            <f7-button fill color="primary" @click.prevent="submitRegister">XÁC NHẬN</f7-button>
        </f7-block>
    </f7-page>
</template>
<script>
export default {
    props:{
        referal: String
    },
    data() {
        return {
            questions: [
                'Biệt danh lúc nhỏ của bạn',
                'Tên đội thể thao yêu thích của bạn',
                '6 số cuối trong CMND/Passport',
                'Tên chú chó đầu tiên bạn nuôi',
                'Tên trường tiểu học mà bạn đã học',
                'Bạn thân của bạn thời thiếu niên',
                'Món ăn mà bạn thích nhất',
                'Bài hát yêu thích của bạn'
            ],
            form_register: {
                fullname: '',
                username: '',
                password: '',
                password_confirmation: '',
                referal: '',
                secret_question_1: 'Biệt danh lúc nhỏ của bạn',
                answer_secret_question_1: '',
                secret_question_2: 'Tên đội thể thao yêu thích của bạn',
                answer_secret_question_2: '',
                account_type: 4
            }
        }
    },
    methods: {
        submitRegister() {
            const app = this.$f7;

            app.dialog.preloader();

            this.form_register.answer_secret_question_1 = (Math.floor(Math.random() * 10000) + 1).toString();
            this.form_register.answer_secret_question_2 = (Math.floor(Math.random() * 10000) + 1).toString();

            this.$store.dispatch('register', this.form_register).then(() => {
                app.dialog.close();
                app.dialog.alert('Tạo tài khoản thành công!', 'THÔNG BÁO', () => {
                    this.$f7.views.main.router.back();
                });
            }).catch((err) => {
                app.dialog.close();
                app.dialog.alert(err, 'LỖI!');
            });
        }
    },
    mounted() {
        this.form_register.referal = this.referal;
    }
};
</script>
